/** @jsx jsx */
import { node, string, shape, func } from 'prop-types'
import { jsx, Flex, Text } from 'theme-ui'
import { useBreakpoint } from '../../utils/useWindowWidth'
import pathwaysBackground2 from '../../images/pathways-background-2.png'
import { CfnButton } from '../common/Buttons'

const InfoPageFrame = ({
  actionButton,
  children,
  desktopBackgroundImg,
  subTitle,
  title,
  ...props
}) => {
  const breakpoint = useBreakpoint()
  const isMobile = breakpoint === 'mobile'

  return (
    <Flex
      data-testid="infoBackground"
      sx={{
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage: [
          `url(${pathwaysBackground2})`,
          `url(${desktopBackgroundImg})`,
        ],
        justifyContent: 'flex-start',
        pb: [200, 383],
      }}
    >
      <Flex
        sx={{
          flexDirection: ['column', 'column', 'column'],
          mb: 5,
          mt: [6, 129],
          px: [5, 8],
        }}
      >
        <Text variant="h2" as="h2" sx={{ mr: [0, 0, 2], lineHeight: 1 }}>
          {title}
        </Text>
        <Text
          variant={isMobile ? 'h6' : 'h5'}
          as={isMobile ? 'h6' : 'h5'}
          sx={{ maxWidth: 600, mt: 5 }}
        >
          {subTitle}
        </Text>
        <Text
          variant={isMobile ? 'mediumText' : 'largeText'}
          color="muted"
          sx={{ maxWidth: 600, lineHeight: 1.125 }}
          {...props}
        >
          {children}
        </Text>
        {actionButton && (
          <CfnButton
            onClick={actionButton.handleClick}
            size="small"
            sx={{ mt: [6, 5], width: 157, height: 50 }}
          >
            {actionButton.name}
          </CfnButton>
        )}
      </Flex>
      {!isMobile && <Flex sx={{ width: '420px', height: '100px' }}></Flex>}
    </Flex>
  )
}

InfoPageFrame.propTypes = {
  actionButton: shape({
    name: string.isRequired,
    handleClick: func.isRequired,
  }),
  bodyText: string,
  children: node,
  desktopBackgroundImg: string,
  subTitle: string,
  title: string.isRequired,
}

export default InfoPageFrame
